import { Session } from 'smg/customer-api/session';
import { Input } from 'smg/customer-api/promos';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { GetFirstAndLast } from 'smg/users';

import * as buttons from 'smg/buttons';
import * as models from 'smg/customer-api/models';
import * as quoterequests from 'smg/customer-api/quoterequests';

import { Uploader } from '../components/uploader';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

main();

function main() {
    const $form = document.querySelector<HTMLFormElement>('#rush-quote-form') as HTMLFormElement;
    const $sectionSport = $form.querySelector<HTMLDivElement>('#section-sport') as HTMLDivElement;
    const $sectionShape = $form.querySelector<HTMLDivElement>('#section-shape') as HTMLDivElement;
    const $sectionContact = $form.querySelector<HTMLDivElement>('#section-contact') as HTMLDivElement;

    const $fieldset = $form.querySelector<HTMLFieldSetElement>('#rush-quote-form-fieldset') as HTMLFieldSetElement;

    const $sportBaseball = $sectionSport.querySelector<HTMLInputElement>('#sport-baseball') as HTMLInputElement;
    const $sportSoftball = $sectionSport.querySelector<HTMLInputElement>('#sport-softball') as HTMLInputElement;

    const $rushQuoteQuantity = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-quantity') as HTMLInputElement;
    const $rushQuoteProjectName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-project-name') as HTMLInputElement;
    const $rushQuoteTeamName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-team-name') as HTMLInputElement;
    const $rushQuoteTeamColors = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-team-colors') as HTMLInputElement;
    const $rushQuoteUploadLabel = $sectionContact.querySelector<HTMLLabelElement>('.uploader-dropzone') as HTMLLabelElement;
    const $rushQuoteNotes = $sectionContact.querySelector<HTMLTextAreaElement>('#rush-quote-notes') as HTMLTextAreaElement;
    const $rushQuoteName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-name') as HTMLInputElement;
    const $rushQuoteEmail = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-email') as HTMLInputElement;
    const $rushQuotePhone = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-phone') as HTMLInputElement;
    const $rushQuoteDate = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-date') as HTMLInputElement;
    BlockPastDates($rushQuoteDate, { earliest: 'tomorrow' });
    const $rushQuotePromo = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-promo') as HTMLInputElement;

    const $rushQuoteFormSubmit = $form.querySelector<HTMLButtonElement>('#rush-quote-form-submit') as HTMLButtonElement;

    const uploader = new Uploader($rushQuoteUploadLabel);
    const phone = new Phone($rushQuotePhone);

    $form.reset();

    const $promoCodeSuccess = $sectionContact.querySelector<HTMLElement>('#promo-code-success') as HTMLElement;
    const $promoCodeTitle = $promoCodeSuccess.querySelector<HTMLElement>('#promo-code-title') as HTMLElement;
    const $promoCodeDescription = $promoCodeSuccess.querySelector<HTMLElement>('#promo-code-description') as HTMLElement;

    const promo = new Input($rushQuotePromo, {
        success: p => {
            $promoCodeTitle.textContent = p.name;
            $promoCodeDescription.textContent = p.description;
            $promoCodeSuccess.classList.remove('d-none');
        },
        error: () => {
            $promoCodeSuccess.classList.add('d-none');
            $promoCodeTitle.textContent = '';
            $promoCodeDescription.textContent = '';
        },
    });

    $sectionSport.addEventListener('change', () => {
        if (!$sectionSport.querySelector('input:checked')) {
            return;
        }

        const isSoftball = $sportSoftball.checked;
        $sectionShape.querySelectorAll<HTMLElement>('.baseball-img').forEach($img => $img.classList.toggle('d-none', isSoftball));
        $sectionShape.querySelectorAll<HTMLElement>('.softball-img').forEach($img => $img.classList.toggle('d-none', !isSoftball));

        if ($sectionShape.classList.contains('d-none')) {
            $sectionShape.classList.remove('d-none');
            $sectionShape.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionShape.addEventListener('click', () => {
        if ($sectionShape.querySelector('input:checked') && $sectionContact.classList.contains('d-none')) {
            $sectionContact.classList.remove('d-none');
            $sectionContact.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $rushQuoteFormSubmit.addEventListener('click', async e => {
        e.preventDefault();

        await promo.check();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($rushQuoteFormSubmit);
        const extras: models.QuoteRequestCreateExtra[] = [];
        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Team Name',
            value: $rushQuoteTeamName.value,
        }));
        if ($rushQuoteTeamColors.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Team Colors',
                value: $rushQuoteTeamColors.value,
            }));
        }

        if ($sportBaseball.checked) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Sport',
                value: 'Baseball',
            }));
        } else if ($sportSoftball.checked) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Sport',
                value: 'Softball',
            }));
        }

        let shape;
        const $selectedShape = $sectionShape.querySelector<HTMLInputElement>('input[name="rush-quote-shape"]:checked');
        if ($selectedShape) {
            shape = $selectedShape.value;
        }

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch/finally below and leave the form disabled.
        let uploadIDs: number[];
        try {
            uploadIDs = await uploader.getUploadIDs();
        } catch (err) {
            ShowError(err);
            $fieldset.disabled = false;
            buttons.Stop($rushQuoteFormSubmit);
            return;
        }

        quoterequests.NewQuoteRequest({
            form: 'rush pin quote form',
            name: $rushQuoteName.value,
            company: $rushQuoteTeamName.value,
            phone: await phone.format(),
            email: $rushQuoteEmail.value,
            lineItem: 'Lapel Pins',
            type: 'Made in USA - Rush Pins',
            size: shape,
            quantity: $rushQuoteQuantity.value ? parseInt($rushQuoteQuantity.value, 10) : undefined,
            promo: $rushQuotePromo.value || undefined,
            project: $rushQuoteProjectName.value || `${new Date().getFullYear()} ${$rushQuoteTeamName.value}`,
            dateNeeded: $rushQuoteDate.value || undefined,
            notes: $rushQuoteNotes.value || undefined,
            extras,
            uploadIDs,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($rushQuoteName.value));
            dataLayer.push({
                'event': 'hs-module-quote-form-success',
                'userData': {
                    'email': sess?.user.emailAddress.email || $rushQuoteEmail.value,
                    'phone': sess?.user.phoneNumber.phone || await phone.format(),
                    'firstName': sess?.user.firstName || firstName,
                    'lastName': sess?.user.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            window.location.href = `${Relref('/free-quote/thank-you')}?id=${quoteRequest.quotes?.[0].key ?? ''}`;
        }).catch(err => {
            ShowError(err);
            $fieldset.disabled = false;
            buttons.Stop($rushQuoteFormSubmit);
        });
        return;
    });
}